export default {
  QUEUE: 'queue',
  APPROVED: 'approved',
  COMPLETED: 'completed',
}
